// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unread-badge {
  /* Use a brand color variable, e.g., from your main CSS file */
  background-color: var(--netsfere-red, #d92d20);
  color: var(--white, #ffffff);
  border-radius: 50%;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  box-sizing: border-box;

  /* Center the number inside the circle */
  display: inline-flex;
  align-items: center;
  justify-content: center;

  /* Font styling */
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/UnreadBadge.css"],"names":[],"mappings":"AAAA;EACE,8DAA8D;EAC9D,8CAA8C;EAC9C,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,sBAAsB;;EAEtB,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;;EAEvB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".unread-badge {\n  /* Use a brand color variable, e.g., from your main CSS file */\n  background-color: var(--netsfere-red, #d92d20);\n  color: var(--white, #ffffff);\n  border-radius: 50%;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  box-sizing: border-box;\n\n  /* Center the number inside the circle */\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  /* Font styling */\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
